import { render, staticRenderFns } from "./EditorialLayout.vue?vue&type=template&id=16778cef&scoped=true"
import script from "./EditorialLayout.vue?vue&type=script&lang=js"
export * from "./EditorialLayout.vue?vue&type=script&lang=js"
import style0 from "./EditorialLayout.vue?vue&type=style&index=0&id=16778cef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16778cef",
  null
  
)

export default component.exports